export default __webpack_public_path__ + "static/media/helpTips.6651457b.webp";